import React, { createContext, useContext } from "react";
import { getCookie, setCookie, encodeThai, getCookieData } from "../common/Common";
const { BehaviorSubject, Observable, defer } = rxjs;
const { tap, map, filter, first } = rxjs.operators;

export class CompareStore {
  compareProperty$ = new BehaviorSubject([]);

  comparePropertyLength$ = this.compareProperty$.pipe(
    map((item) => item.length)
  );

  constructor() {
    window.openErrorPopup = this.openErrorPopup;

    console.log("compare cookie" + getCookie("compareProperty"));

    const initValue = getCookie("compareProperty") !== ""
      ? JSON.parse(getCookie("compareProperty"))
      : []
    // window.setTimeout(() => {
    //   this.compareProperty$.next(initValue);
    // }, 1000)
    console.log(getCookieData)
    var result = getCookieData(initValue).then((data) => {
      data.Items.forEach(element => this.addCompareProperty(element, false));
    })
  }

  openErrorPopup(message) {
    $("#error-popup div div p").html(message);
    $("#error-popup").css({
      display: "flex",
    });

    $("#close-error-popup").on("click", function () {
      $("#error-popup").css({
        display: "",
      });
    });
  }

  addCompareProperty(prop, show = true) {
    let comparePropertyList = this.compareProperty$.value;

    if (
      comparePropertyList.some((item) => item.PropertyID === prop.PropertyID)
    ) {
      this.compareProperty$.next([...comparePropertyList]);
      return;
    }

    comparePropertyList = comparePropertyList.filter((item) => item);

    if (comparePropertyList.length >= 5) {
      openErrorPopup("เลือกได้ไม่เกิน 5 ทรัพย์");
      return;
    }

    let PropertyMediaes = (prop?.PropertyMediaes === "") ? [] : prop.PropertyMediaes;

    // const newProperty = {
    //   ...prop,
    //   PropertyMediaes: [
    //     ...prop.PropertyMediaes.filter(
    //       (item) => item.MediaType === "IMAGE-THUMBNAIL"
    //     ),
    //   ],
    //   NearbyPlaces: null,
    //   PropertiesInfoRelated: null,
    // };

    const newProperty = {
      PropertyID: prop.PropertyID,
      PropertyIDFormat: prop.PropertyIDFormat,
      VillageTH: prop.VillageTH,
      PropertyTypeName: prop.PropertyTypeName,
      PromotionPrice: prop.PromotionPrice,
      AdjustPrice: prop.AdjustPrice,
      SellPrice: prop.SellPrice,
      PMMaintenanceStatus: prop.PMMaintenanceStatus,
      AmphurName: prop.AmphurName,
      ProvinceName: prop.ProvinceName,
      AreaValue: prop.AreaValue,
      UseableArea: prop.UseableArea,
      Bedroom: prop.Bedroom,
      Bathroom: prop.Bathroom,
      BuildingAge: prop.BuildingAge ?? prop.Age,
      PropertyMediaes: [
        ...PropertyMediaes.filter(
          (item) => item.MediaType === "IMAGE-THUMBNAIL"
        ),
      ],
    };

    comparePropertyList = [...comparePropertyList, { ...newProperty }];

    setCookie("compareProperty", JSON.stringify(Array.from(comparePropertyList, x => x.PropertyID)), 30);
    // setCookie("compareProperty", JSON.stringify(comparePropertyList.map((item) => { return encodeThai(item) })), 30);

    console.log("compare after set cookie" + getCookie("compareProperty"));

    this.compareProperty$.next([...comparePropertyList]);

    let section_comparision = $("#comparision");
    if (show) section_comparision.addClass("active");

    return [...comparePropertyList];
  }

  removeCompareProperty(prop) {
    let comparePropertyList = this.compareProperty$.value;

    comparePropertyList = comparePropertyList.filter(
      (item) => item.PropertyID !== prop.PropertyID
    );

    setCookie("compareProperty", JSON.stringify([...comparePropertyList]), 30);

    this.compareProperty$.next([...comparePropertyList]);
  }

  removeAllCompareProperty() {
    let comparePropertyList = this.compareProperty$.value;

    comparePropertyList = [];

    setCookie("compareProperty", JSON.stringify([...comparePropertyList]), 30);

    this.compareProperty$.next([...comparePropertyList]);
  }

  canAddCompareProperty = (prop = null) =>
    this.compareProperty$.pipe(
      map((list) =>
        prop ? !(list.PropertyID === prop.PropertyID) : list.length <= 5
      )
    );

  isExistCompareProperty = (prop = null) =>
    this.compareProperty$.pipe(
      map((list) => {
        const isCompared = list.some(
          (item) => item.PropertyID === prop.PropertyID
        );
        return isCompared;
      })
    );

  getComparePropertyList = this.compareProperty$.pipe(
    map((list) => {
      const result = [
        ...list,
        ...Array.from({ length: Math.abs(list.length - 5) }, (_) => null),
      ];
      return result;
    })
  );
}

const compareStore = new CompareStore();

export const COMPARE_STORE_CONTEXT = createContext(compareStore);

export const CompareStoreProvider = (prop) => {
  return (
    <COMPARE_STORE_CONTEXT.Provider value={compareStore}>
      {prop.children}
    </COMPARE_STORE_CONTEXT.Provider>
  );
};
